
export default function PipelineAmp() {
  const features = [
    {
      icon: 'ri-computer-line',
      title: 'High-Converting Website & Landing Pages',
      description: 'Present Your Brand & Convert Leads'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Search Engine Optimization',
      description: 'Get Found in Search Engines'
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Digital Ads',
      description: 'Top Converting Ads on Google, Meta, and others'
    },
    {
      icon: 'ri-share-line',
      title: 'Digital Marketing Solutions',
      description: 'Present Your Brand on Social Media'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Automated Lead Nurturing System',
      description: 'Use the All-in-One Automation System to Convert More Leads'
    },
    {
      icon: 'ri-brain-line',
      title: 'Artificial Intelligence',
      description: 'Pipeline Amp allows you to leverage AI (Artificial Intelligence) and Machine Learning to manage the conversation'
    },
    {
      icon: 'ri-video-line',
      title: 'Video Production & Marketing',
      description: 'Create Engaging Videos of Your Brand'
    },
    {
      icon: 'ri-star-line',
      title: 'Reputation Management',
      description: 'Increase Your Online Presence and Reputation'
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Tracking & Conversion Monitoring',
      description: 'Listen to the calls'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Analytics & Reporting',
      description: 'Get easy-to-understand reports and analytics of the data'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support',
      description: 'We are here for you all the steps of the way'
    },
    {
      icon: 'ri-contacts-book-line',
      title: 'CRM System',
      description: 'It is an easy-to-use and easy-to-understand Customer Relationship Management system.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#1a0a1e] via-[#2d1233] to-[#1a0a1e] relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Header Section */}
        <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
          {/* Left - Logo and Title */}
          <div>
            {/* Pipeline Amp Logo */}
            <div className="flex items-center gap-3 mb-6">
              <div className="w-16 h-16 flex items-center justify-center bg-red-500 rounded-full">
                <i className="ri-flashlight-fill text-white text-3xl"></i>
              </div>
              <div>
                <span className="text-white text-3xl font-bold">Pipeline</span>
                <span className="text-red-500 text-3xl font-bold italic">AMP</span>
              </div>
            </div>
            
            {/* Main Title */}
            <h2 className="text-5xl md:text-6xl font-black text-white mb-2">
              CONTRACTOR
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-white/90">
              ALL-IN-ONE MARKETING<br />
              SOLUTION SYSTEM
            </h3>
          </div>

          {/* Right - Video */}
          <div className="relative">
            <div className="bg-[#1e3a5f] rounded-xl p-3 shadow-2xl">
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src="https://player.vimeo.com/video/910091394?h=3eaade767c&title=0&byline=0&portrait=0"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title="Pipeline Amp Marketing Solution"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-5 hover:bg-white/10 transition-all duration-300 border border-white/10"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#4a1942] rounded-lg flex-shrink-0">
                <i className={`${feature.icon} text-red-400 text-xl`}></i>
              </div>
              <div>
                <h4 className="text-white font-bold text-lg mb-1">{feature.title}</h4>
                <p className="text-gray-400 text-sm">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <a
            href="https://www.pipelineamp.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-600 transition-all shadow-lg hover:shadow-red-500/30 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Get Started with Pipeline Amp
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
